export class FraseSecretaRequest{

    fraseSecreta: string;
    confirmacaoFrase: string;

}